import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { sendCustomTrackingInfo } from '@panel/commons';
import { zonesKeys } from '../../helpers/getWordingsZones';
import {
  Container,
  Title,
  ListContainer,
  RowZone,
  Icon,
  SubZoneContainer,
  HiddenSubZoneContainer,
  CTAMoreZones,
  TextInfo,
  CTA
} from './styles';

const ZoneDemandList = ({ device, handleClick, plansRef, siteId }) => {
  const { t } = useTranslation();
  const [active, setActive] = useState('');

  const orderedZonesKeys = zonesKeys[siteId]
    ? zonesKeys[siteId].sort((a, b) => {
        if (a.zone > b.zone) return 1;
        if (a.zone < b.zone) return -1;
        return 0;
      })
    : [];

  return (
    <Container device={device} data-panel='landingZD-mapSection-listContainer'>
      {device !== 'mobile' && (
        <Title device={device} data-panel='landingZD-mapSection-listContainer-title'>
          {t('panel.landing_ZD.maps.title')}
        </Title>
      )}
      <ListContainer device={device}>
        {orderedZonesKeys.map(location => {
          return (
            <RowZone device={device} key={location.zone}>
              <Icon data-panel={`landingZD-mapSection-listContainer-icon-${location.zone}`} />
              <div className='column-zone'>
                <div
                  className='title-zone'
                  data-panel={`landingZD-mapSection-listContainer-titleZone-${location.zone}`}
                >
                  {location.zone}
                </div>
                {location.subzone && (
                  <SubZoneContainer
                    data-panel={`landingZD-mapSection-listContainer-subzone-${location.zone}`}
                    active={active === location.zone}
                  >
                    {location.subzone}
                  </SubZoneContainer>
                )}
                {location.hiddenSubzone && (
                  <HiddenSubZoneContainer
                    device={device}
                    data-panel={`landingZD-mapSection-listContainer-subzoneHidden-${location.zone}`}
                    onClick={() => setActive(false)}
                    active={active === location.zone}
                  >
                    {location.hiddenSubzone}
                  </HiddenSubZoneContainer>
                )}
                {location.withMoreZonesCTA && (
                  <CTAMoreZones
                    device={device}
                    data-panel={`landingZD-mapSection-listContainer-CTAMore-${location.zone}`}
                    onClick={() => {
                      setActive(location.zone);
                      sendCustomTrackingInfo({
                        event: 'select_content',
                        content_type: 'Click a Ver más subzonas',
                        item_id: location.zone
                      });
                    }}
                    active={active === location.zone}
                    topM={location.topM}
                    topD={location.topD}
                    topTV={location.topTV}
                    topTH={location.topTH}
                    leftM={location.leftM}
                    leftD={location.leftD}
                    leftTV={location.leftTV}
                    leftTH={location.leftTH}
                  >
                    {t('panel.landing_ZD.maps.moreZones')}
                  </CTAMoreZones>
                )}
              </div>
            </RowZone>
          );
        })}
      </ListContainer>
      <div className='info-cta'>
        <TextInfo device={device} data-panel='landingZD-mapSection-listContainer-textInfo'>
          {t('panel.landing_ZD.maps.text.info')}
        </TextInfo>
        <CTA
          device={device}
          data-panel='landingZD-mapSection-listContainer-CTA'
          onClick={() => {
            handleClick(plansRef, 'center');
            sendCustomTrackingInfo({
              event: 'select_content',
              content_type: 'CTAs landing',
              item_id: 'Ver planes'
            });
          }}
        >
          {t('panel.landing_ZD.maps.cta')}
        </CTA>
      </div>
    </Container>
  );
};

export default ZoneDemandList;
